import { getAllAreasOptions } from '@app/api/area';
import { getAllDepartamentoOptions } from '@app/api/departamento';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllFornecedoresOptions } from '@app/api/fornecedor';
import {
  relatorioExportExcel,
  RelatorioStatusMedicoes,
  RelatorioStatusMedicoesResume,
  ResumoMedicoesFilter,
  searchValues,
} from '@app/api/relatorioStatusMedicoes';
import { getAllAnalistaGPCOptions } from '@app/api/usuario';
import { ExcelButton, SearchButton } from '@app/components/FormButtons';
import { compareCurrencyValue, compareDates, compareText } from '@app/helpers/comparators';
import { dateFormat } from '@app/helpers/dateTimeFormats';
import {
  Button,
  Col,
  Widget,
  Form,
  FormInput,
  FormRangePicker,
  FormResetButton,
  FormSelect,
  GridView,
  Row,
  SimpleView,
  Table,
  FilterWidget,
  CompositeView,
} from '@digital/ui';
import { Icon } from 'antd';
import React, { useEffect, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { currencyFormat } from '../../helpers/numbers';
import '../Contrato/custom.css';
import { FormSelectFilter } from '@app/components/FormSelectFilter';

const RelatorioStatusMedicoes = () => {
  const [items, setItems] = useState<RelatorioStatusMedicoes[]>();
  const [resume, setResume] = useState<RelatorioStatusMedicoesResume[]>([]);
  const [getList, setGetList] = useState<boolean>(true);
  const [documentoAcessorioAtivo, setDocumentoAcessorioAtivo] = useState<boolean>(true);

  useEffect(() => {
    var obj = {} as ResumoMedicoesFilter;
    handleFilter(obj);
  }, [getList]);

  const colunaTipoBoletimMedicao = {
    title: 'Tipo do BM',
    dataIndex: 'tipoBoletimMedicao',
    width: '5%',
    sorter: (a, b) => compareText(a.tipoBoletimMedicao, b.tipoBoletimMedicao),
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <Form>
        <Row>
          <FormInput
            placeholder="Pesquisar Tipo do BM"
            name="tipoBoletimMedicao"
            style={{ marginTop: '15px' }}
            onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => {})}
            onPressEnter={() => {
              if (typeof confirm === 'function') confirm();
            }}
          />
        </Row>
        <Row>
          <Col span={6}>
            <Button
              type="primary"
              style={{ marginLeft: '5px' }}
              onClick={() => {
                if (typeof confirm === 'function') confirm();
              }}
              icon="commons-search"
              size="small">
              Pesquisar
            </Button>
          </Col>
          <Col span={6}>
            <FormResetButton
              size="small"
              style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
              beforeReset={() => {
                if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
              }}>
              Limpar
            </FormResetButton>
          </Col>
        </Row>
      </Form>
    ),
    filterIcon: filtered => {
      const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

      return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
    },
    onFilter: (value, record) =>
      record.tipoBoletimMedicao &&
      record.tipoBoletimMedicao
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
  };

  const columnResumo = [
    {
      title: 'Quantidade Total de Medições',
      dataIndex: 'qtnDeMedicoes',
      width: '20%',
    },
    {
      title: 'Medições Em Andamento',
      dataIndex: 'qtnMedicoesEmAndamento',
      width: '20%',
    },
    {
      title: 'Medições Não Lançadas',
      dataIndex: 'qtnMedicoesNaoLancadas',
      width: '20%',
    },
    {
      title: 'Medições Concluídas',
      dataIndex: 'qtnMedicoesConcluidas',
      width: '20%',
    },
    {
      title: 'Valor Medições Concluídas',
      dataIndex: 'valorMedicoesConcluidas',
      render: currencyFormat,
      width: '20%',
    },
  ];

  const columnMedicoes = [
    {
      title: 'CT',
      dataIndex: 'numeroContrato',
      width: '5%',
      sorter: (a, b) => compareText(a.numeroContrato, b.numeroContrato),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Contrato"
              name="numeroContrato"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.numeroContrato &&
        record.numeroContrato
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Fornecedor',
      dataIndex: 'fornecedor',
      width: '5%',
      sorter: (a, b) => compareText(a.fornecedor, b.fornecedor),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Fornecedor"
              name="fornecedor"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.fornecedor &&
        record.fornecedor
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Dir.',
      dataIndex: 'diretoria',
      width: '5%',
      sorter: (a, b) => compareText(a.diretoria, b.diretoria),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Diretoria"
              name="diretoria"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.diretoria &&
        record.diretoria
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Área',
      dataIndex: 'area',
      width: '5%',
      sorter: (a, b) => compareText(a.area, b.area),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Área"
              name="area"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.area &&
        record.area
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Dep.',
      dataIndex: 'departamento',
      width: '5%',
      sorter: (a, b) => compareText(a.departamento, b.departamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Departamento"
              name="departamento"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.departamento &&
        record.departamento
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Nº BM.',
      dataIndex: 'numeroBM',
      width: '5%',
      sorter: (a, b) => compareText(a.departamento, b.departamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Nº BM"
              name="numero"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.numeroBM &&
        record.numeroBM
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    colunaTipoBoletimMedicao,
    {
      title: 'PQ',
      dataIndex: 'identificadorPQ',
      width: '5%',
      sorter: (a, b) => compareText(a.numeroContrato, b.numeroContrato),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar PQ"
              name="identificadorPQ"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.identificadorPQ &&
        record.identificadorPQ
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Data de Criação',
      dataIndex: 'dataCriacaoBM',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataCriacaoBM, b.dataCriacaoBM),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data de Criação"
              name="dataCriacaoBM"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataCriacaoBM &&
        record.dataCriacaoBM
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Início',
      dataIndex: 'dataInicio',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataInicio, b.dataInicio),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data de Início"
              name="dataInicio"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataInicio &&
        record.dataInicio
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Fim',
      dataIndex: 'dataFim',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataFim, b.dataFim),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data de Fim"
              name="dataFim"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataFim &&
        record.dataFim
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Valor BM',
      dataIndex: 'valorBM',
      width: '10%',
      render: currencyFormat,
      sorter: (a, b) => compareCurrencyValue(a.valorBM, b.valorBM),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Valor BM"
              name="valorBM"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.valorBM &&
        record.valorBM
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Possui SLA',
      dataIndex: 'possuiSLA',
      width: '5%',
      sorter: (a, b) => compareText(a.possuiSLA, b.possuiSLA),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar SLA"
              name="possuiSLA"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.possuiSLA &&
        record.possuiSLA
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Bônus',
      dataIndex: 'bonus',
      width: '5%',
      render: currencyFormat,
      sorter: (a, b) => compareCurrencyValue(a.bonus, b.bonus),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Bônus"
              name="bonus"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.bonus &&
        record.bonus
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Penalti',
      dataIndex: 'penalti',
      width: '5%',
      render: currencyFormat,
      sorter: (a, b) => compareCurrencyValue(a.penalti, b.penalti),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Penalti"
              name="penalti"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.penalti &&
        record.penalti
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Início do Status',
      dataIndex: 'dataTrocaStatus',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataTrocaStatus, b.dataTrocaStatus),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Início do Status"
              name="dataTrocaStatus"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataTrocaStatus &&
        record.dataTrocaStatus
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Status Medição',
      dataIndex: 'statusMedicao',
      width: '5%',
      sorter: (a, b) => compareText(a.statusMedicao, b.statusMedicao),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Status Medição"
              name="statusMedicao"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.statusMedicao &&
        record.statusMedicao
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Início do Status - Rateio',
      dataIndex: 'dataStatusRateio',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataStatusRateio, b.dataStatusRateio),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Início do Status - Rateio"
              name="dataStatusRateio"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataStatusRateio &&
        record.dataStatusRateio
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Status Rateio Geral',
      dataIndex: 'statusRateio',
      width: '5%',
      sorter: (a, b) => compareText(a.statusMedicao, b.statusMedicao),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Status Rateio Geral"
              name="statusRateio"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.statusRateio &&
        record.statusRateio
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Início do Status - Autorização',
      dataIndex: 'dataHoraUltimaTrocaStatusAutorizacaoPagamento',
      width: '5%',
      sorter: (a, b) =>
        compareDates(a.dataHoraUltimaTrocaStatusAutorizacaoPagamento, b.dataHoraUltimaTrocaStatusAutorizacaoPagamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Início do Status - Autorização"
              name="dataHoraUltimaTrocaStatusAutorizacaoPagamento"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataHoraUltimaTrocaStatusAutorizacaoPagamento &&
        record.dataHoraUltimaTrocaStatusAutorizacaoPagamento
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Status Autorização',
      dataIndex: 'statusAutorizacaoPagamento',
      width: '10%',
      sorter: (a, b) => compareText(a.statusAutorizacaoPagamento, b.statusAutorizacaoPagamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Aguardando Autorização"
              name="statusAutorizacaoPagamento"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.statusAutorizacaoPagamento &&
        record.statusAutorizacaoPagamento
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Status Doc. Acess. Mensal',
      dataIndex: 'statusDocumentacaoAcessoriaMensal',
      width: '10%',
      sorter: (a, b) => compareText(a.statusDocumentacaoAcessoriaMensal, b.statusDocumentacaoAcessoriaMensal),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Status Doc. Acess. Mensal"
              name="statusDocumentacaoAcessoriaMensal"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.statusDocumentacaoAcessoriaMensal &&
        record.statusDocumentacaoAcessoriaMensal
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Analista GPC',
      dataIndex: 'analistaGPC',
      width: '5%',
      sorter: (a, b) => compareText(a.analistaGPC, b.analistaGPC),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Analista GPC"
              name="analistaGPC"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.analistaGPC &&
        record.analistaGPC
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
  ];

  const columnMedicoesSemDocumentacaoAcessorial = [
    {
      title: 'CT',
      dataIndex: 'numeroContrato',
      width: '5%',
      sorter: (a, b) => compareText(a.numeroContrato, b.numeroContrato),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Contrato"
              name="numeroContrato"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.numeroContrato &&
        record.numeroContrato
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Fornecedor',
      dataIndex: 'fornecedor',
      width: '5%',
      sorter: (a, b) => compareText(a.fornecedor, b.fornecedor),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Fornecedor"
              name="fornecedor"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.fornecedor &&
        record.fornecedor
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Dir.',
      dataIndex: 'diretoria',
      width: '5%',
      sorter: (a, b) => compareText(a.diretoria, b.diretoria),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Diretoria"
              name="diretoria"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.diretoria &&
        record.diretoria
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Área',
      dataIndex: 'area',
      width: '5%',
      sorter: (a, b) => compareText(a.area, b.area),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Área"
              name="area"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.area &&
        record.area
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Dep.',
      dataIndex: 'departamento',
      width: '5%',
      sorter: (a, b) => compareText(a.departamento, b.departamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Departamento"
              name="departamento"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.departamento &&
        record.departamento
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Nº BM.',
      dataIndex: 'numeroBM',
      width: '5%',
      sorter: (a, b) => compareText(a.departamento, b.departamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Nº BM"
              name="numeroBM"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.numeroBM &&
        record.numeroBM
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    colunaTipoBoletimMedicao,
    {
      title: 'PQ',
      dataIndex: 'identificadorPQ',
      width: '5%',
      sorter: (a, b) => compareText(a.numeroContrato, b.numeroContrato),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar PQ"
              name="identificadorPQ"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.identificadorPQ &&
        record.identificadorPQ
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Data de Criação',
      dataIndex: 'dataCriacaoBM',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataCriacaoBM, b.dataCriacaoBM),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data de Criação"
              name="dataCriacaoBM"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataCriacaoBM &&
        record.dataCriacaoBM
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Início',
      dataIndex: 'dataInicio',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataInicio, b.dataInicio),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data de Início"
              name="dataInicio"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataInicio &&
        record.dataInicio
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Fim',
      dataIndex: 'dataFim',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataFim, b.dataFim),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Data de Fim"
              name="dataFim"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataFim &&
        record.dataFim
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Valor BM',
      dataIndex: 'valorBM',
      width: '10%',
      render: currencyFormat,
      sorter: (a, b) => compareCurrencyValue(a.valorBM, b.valorBM),
    },
    {
      title: 'Possui SLA',
      dataIndex: 'possuiSLA',
      width: '5%',
      sorter: (a, b) => compareText(a.possuiSLA, b.possuiSLA),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar SLA"
              name="possuiSLA"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.possuiSLA &&
        record.possuiSLA
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Bônus',
      dataIndex: 'bonus',
      width: '5%',
      render: currencyFormat,
      sorter: (a, b) => compareCurrencyValue(a.bonus, b.bonus),
    },
    {
      title: 'Penalti',
      dataIndex: 'penalti',
      width: '5%',
      render: currencyFormat,
      sorter: (a, b) => compareCurrencyValue(a.penalti, b.penalti),
    },
    {
      title: 'Início do Status',
      dataIndex: 'dataTrocaStatus',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataTrocaStatus, b.dataTrocaStatus),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Início do Status"
              name="dataTrocaStatus"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataTrocaStatus &&
        record.dataTrocaStatus
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Status Medição',
      dataIndex: 'statusMedicao',
      width: '5%',
      sorter: (a, b) => compareText(a.statusMedicao, b.statusMedicao),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Status Medição"
              name="statusMedicao"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.statusMedicao &&
        record.statusMedicao
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Início do Status - Rateio',
      dataIndex: 'dataStatusRateio',
      width: '5%',
      sorter: (a, b) => compareDates(a.dataStatusRateio, b.dataStatusRateio),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Início do Status - Rateio"
              name="dataStatusRateio"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataStatusRateio &&
        record.dataStatusRateio
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Status Rateio Geral',
      dataIndex: 'statusRateio',
      width: '5%',
      sorter: (a, b) => compareText(a.statusMedicao, b.statusMedicao),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Status Rateio Geral"
              name="statusRateio"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.statusRateio &&
        record.statusRateio
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Início do Status - Autorização',
      dataIndex: 'dataHoraUltimaTrocaStatusAutorizacaoPagamento',
      width: '5%',
      sorter: (a, b) =>
        compareDates(a.dataHoraUltimaTrocaStatusAutorizacaoPagamento, b.dataHoraUltimaTrocaStatusAutorizacaoPagamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Início do Status - Autorização"
              name="dataHoraUltimaTrocaStatusAutorizacaoPagamento"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.dataHoraUltimaTrocaStatusAutorizacaoPagamento &&
        record.dataHoraUltimaTrocaStatusAutorizacaoPagamento
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Status Autorização',
      dataIndex: 'statusAutorizacaoPagamento',
      width: '10%',
      sorter: (a, b) => compareText(a.statusAutorizacaoPagamento, b.statusAutorizacaoPagamento),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Aguardando Autorização"
              name="statusAutorizacaoPagamento"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.statusAutorizacaoPagamento &&
        record.statusAutorizacaoPagamento
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
    {
      title: 'Analista GPC',
      dataIndex: 'analistaGPC',
      width: '5%',
      sorter: (a, b) => compareText(a.analistaGPC, b.analistaGPC),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <Form>
          <Row>
            <FormInput
              placeholder="Pesquisar Analista GPC"
              name="analistaGPC"
              style={{ marginTop: '15px' }}
              onChange={e => (setSelectedKeys ? setSelectedKeys(e.target.value ? [e.target.value] : []) : () => { })}
              onPressEnter={() => {
                if (typeof confirm === 'function') confirm();
              }}
            />
          </Row>
          <Row>
            <Col span={6}>
              <Button
                type="primary"
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  if (typeof confirm === 'function') confirm();
                }}
                icon="commons-search"
                size="small">
                Pesquisar
              </Button>
            </Col>
            <Col span={6}>
              <FormResetButton
                size="small"
                style={{ float: 'right', marginRight: '5px', marginBottom: '15px' }}
                beforeReset={() => {
                  if (typeof clearFilters === 'function') clearFilters(selectedKeys || []);
                }}>
                Limpar
              </FormResetButton>
            </Col>
          </Row>
        </Form>
      ),
      filterIcon: filtered => {
        const classes = filtered ? 'anticon-filter ant-table-filter-selected' : '';

        return <Icon type="search" className={classes} style={{ minWidth: 'auto', border: 'none' }} />;
      },
      onFilter: (value, record) =>
        record.analistaGPC &&
        record.analistaGPC
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase()),
    },
  ];

  const handleFilter = async (values: ResumoMedicoesFilter) => {
    searchValues(values).then(resp => {
      if (resp) {
        setDocumentoAcessorioAtivo(resp.gerirDocumentacaoAcessoria);
        setItems(resp.relatorioStatusMedicoes);
        setResume(resp.relatorioStatusMedicoesResume);
      }
    });
  };

  const handleExcel = async (values: ResumoMedicoesFilter) => {
    relatorioExportExcel(values);
  };

  return (
    <CompositeView>
      <SimpleView>
        <GridView onSubmit={handleFilter}>
          <FilterWidget
            active={[]}
            actions={[
              <ExcelButton type="link" key="excelBtn" onClick={handleExcel} />,
              <SearchButton type="primary" key="filterBtn" onClick={handleFilter} />,
            ]}
            title="Filtros">
            <FormRangePicker label="Período" startName="dataInicio" endName="dataFinal" format={dateFormat} span={4} />
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input, item) => {
                return item.props.children.props.id
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              mode="multiple"
              label="Diretoria"
              name="diretoriaIds"
              getOptions={getAllDiretoriasOptions}
              span={4}
            />
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input, item) => {
                return item.props.children.props.id
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              mode="multiple"
              label="Analista GPC"
              name="analistaGPCIds"
              getOptions={getAllAnalistaGPCOptions}
              span={4}
            />
            <FormSelectFilter
              label="Fornecedor"
              name="fornecedorIds"
              span={4}
              dataOptions={() => getAllFornecedoresOptions()}
            />
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input, item) => {
                return item.props.children.props.id
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              mode="multiple"
              label="Area"
              name="areaIds"
              getOptions={getAllAreasOptions}
              span={4}
            />
            <FormSelect
              showSearch
              optionFilterProp="children"
              filterOption={(input, item) => {
                return item.props.children.props.id
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              mode="multiple"
              label="Departamento"
              name="departamentoIds"
              getOptions={getAllDepartamentoOptions}
              span={4}
            />
            <FormInput label="Contrato" name="numeroContrato" span={4} />
          </FilterWidget>
          <Widget title="Resumo">
            <PerfectScrollbar>
              <Table columns={columnResumo} dataSource={resume || []} pagination={false} />
            </PerfectScrollbar>
          </Widget>
          <Widget title="Relatório Status de Medições">
            <PerfectScrollbar>
              <Table
                // className="removeScrollbar"
                columns={documentoAcessorioAtivo ? columnMedicoes : columnMedicoesSemDocumentacaoAcessorial}
                dataSource={items || []}
                pagination={{ pageSize: 100 }}
              />
            </PerfectScrollbar>
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default RelatorioStatusMedicoes;
